import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const CronjobList = Loadable(lazy(() => import('pages/cronjob/List')));
const CronjobView = Loadable(lazy(() => import('pages/cronjob/View')));
const CronjobEdit = Loadable(lazy(() => import('pages/cronjob/Edit')));
const CronjobCreate = Loadable(lazy(() => import('pages/cronjob/Create')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const CronjobRoutes: RouteObject = {
    path: 'cronjob',
    children: [
        {
            path: '',
            element: <CronjobList />,
        },
        {
            path: ':id',
            element: <CronjobView />,
        },
        {
            path: ':id/edit',
            element: <CronjobEdit />,
        },
        {
            path: 'new',
            element: <CronjobCreate />,
        },
    ],
};
export default CronjobRoutes;
